import { useEffect, useRef } from "react";
import { Application, Assets, Sprite } from "pixi.js";

import gearsPng from "../../assets/a_planetary_shift_logo_gears.png";
import casingPng from "../../assets/a_planetary_shift_logo.png";
import wordmarkPng from "../../assets/a_planetary_shift_logo_text.png";

import "./logoWordmark.css";

export default function LogoWordmark({
    size = 200,
    rotationSpeed = 0.03,
    tint = 0xcdcdcd,
    className = "",
}) {
    const pixiRef = useRef(null);

    useEffect(() => {
        let app;
        let gearSprite;

        async function initPixi() {
            app = new Application();

            // const DISPLAY_SIZE = 200;
            const SYMBOL_SIZE = size;
            const SYMBOL_SCALE = SYMBOL_SIZE / 1000;
            const WORDMARK_WIDTH = 1634 * SYMBOL_SCALE;
            const GAP = 20;
            const DISPLAY_WIDTH = SYMBOL_SIZE + GAP + WORDMARK_WIDTH;
            const DISPLAY_HEIGHT = SYMBOL_SIZE;

            await app.init({
                width: DISPLAY_WIDTH,
                height: DISPLAY_HEIGHT,
                backgroundAlpha: 0,
                antialias: true,
                resolution: 2,
                autoDensity: false,
            });

            pixiRef.current.appendChild(app.canvas);

            const [gearsTexture, casingTexture, wordmarkTexture] = await Promise.all([
                Assets.load(gearsPng),
                Assets.load(casingPng),
                Assets.load(wordmarkPng)
            ]);

            // GEARS //
            gearSprite = new Sprite(gearsTexture);
            gearSprite.scale.set(SYMBOL_SCALE);
            gearSprite.anchor.set(0.5);
            gearSprite.x = SYMBOL_SIZE / 2;
            gearSprite.y = DISPLAY_HEIGHT / 2;
            gearSprite.tint = tint;
            // gearSprite.texture.source.scaleMode = "linear";

            // CASING //
            const casingSprite = new Sprite(casingTexture);
            casingSprite.scale.set(SYMBOL_SCALE);
            casingSprite.anchor.set(0.5);
            casingSprite.x = SYMBOL_SIZE / 2;
            casingSprite.y = DISPLAY_HEIGHT / 2;
            casingSprite.tint = tint;
            // casingSprite.texture.source.scaleMode = "linear";

            // WORDMARK //
            const wordmarkSprite = new Sprite(wordmarkTexture);
            wordmarkSprite.scale.set(SYMBOL_SCALE);
            wordmarkSprite.anchor.set(0, 0.5);
            wordmarkSprite.x = SYMBOL_SIZE + GAP;
            wordmarkSprite.y = DISPLAY_HEIGHT / 2;
            wordmarkSprite.tint = tint;

            app.stage.addChild(gearSprite, casingSprite, wordmarkSprite);

            app.ticker.add(() => {
                gearSprite.rotation += rotationSpeed;
            });
        }

        initPixi();

        return () => {
            if (app) {
                app.destroy(true);
            }
        };
    }, [size, rotationSpeed, tint]);

    // return <div className="pixi-logo" ref={pixiRef}></div>
    return (
        <div
            className={`logo-wordmark ${className}`}
            ref={pixiRef}
        ></div>
    );
}